import { computed } from "vue";
import {
  loadFlagsConfig,
  useFlagsConfig,
  FlagName,
} from "@/config/flagsConfig";

export const useFlag = (flagName: FlagName) => {
  const flagsConfig = useFlagsConfig();
  loadFlagsConfig();

  const isFeatureAvailable = computed<boolean>(() => {
    const feature = flagsConfig.value?.[flagName];
    if (typeof feature !== "boolean") return false;
    return feature;
  });

  return { isFeatureAvailable };
};
